
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { RecipeCategory } from "../../types";

interface BasicInfoProps {
  title: string;
  setTitle: (value: string) => void;
  description: string;
  setDescription: (value: string) => void;
  category: RecipeCategory;
  setCategory: (value: RecipeCategory) => void;
}

const BasicInfo: React.FC<BasicInfoProps> = ({
  title,
  setTitle,
  description,
  setDescription,
  category,
  setCategory,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="title">Recipe Title</Label>
          <Input
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter recipe title"
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="category">Category</Label>
          <Select 
            value={category}
            onValueChange={(value) => setCategory(value as RecipeCategory)}
          >
            <SelectTrigger id="category">
              <SelectValue placeholder="Select category" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Holiday Cookies">Holiday Cookies</SelectItem>
              <SelectItem value="Holiday Treats">Holiday Treats</SelectItem>
              <SelectItem value="Christmas Dinner">Christmas Dinner</SelectItem>
              <SelectItem value="Breakfast">Breakfast</SelectItem>
              <SelectItem value="Snacks">Snacks</SelectItem>
              <SelectItem value="Desserts">Desserts</SelectItem>
              <SelectItem value="Drinks">Drinks</SelectItem>
              <SelectItem value="Other">Other</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Enter a brief description of the recipe"
          required
          rows={3}
        />
      </div>
    </>
  );
};

export default BasicInfo;
